module.exports = __webpack_public_path__ + "static/media/fe.bec8e0d9.png";